// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper_XLJuA","tutorialContent":"styles_tutorialContent_CJIXg"};